import React from "react";

function Arrows({ prevSlide, nextSlide }) {
  return (
    <div className="arrows">
      <span className="prev" onClick={prevSlide} style={styles.prev}>
        &#10094;
      </span>
      <span className="next" onClick={nextSlide} style={styles.next}>
        &#10095;
      </span>
    </div>
  );
}
const styles = {
  prev: {
    cursor: "pointer",
    zIndex: "100%",
    position: "absolute",
    top: "50%",
    width: "auto",
    padding: "1rem",
    marginTop: "-3rem",
    fontSize: "40px",
    fontWeight: "bold",
    borderRadius: "0px 5px 5px 0px",
    zIndex: "100",
  },
  next: {
    cursor: "pointer",
    zIndex: "100%",
    position: "absolute",
    top: "50%",
    width: "auto",
    padding: "1rem",
    marginTop: "-3rem",
    fontSize: "40px",
    fontWeight: "bold",
    borderRadius: "0px 5px 5px 0px",
    right: "0",
    borderRadius: "5px 0px 0px 5px",
    zIndex: "100",
  },

  // .prev:hover,
  // .next:hover {
  //     color: white;
  //     background-color: rgba(0, 0, 0, 0.6);
  //     transition: all 0.5s ease-in;
  // }
};
export default Arrows;
